module.exports = __webpack_public_path__ + "media/images/games/k2gender/readingbooks-68caf3bec02668a2508a8847384137a1.png";